import { Component, Input, OnInit, ViewContainerRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GrantService } from '../../_services/grant.service';
import { HouseholdMember } from '../../_models/household-member';
import { ModalDirective } from 'ng2-bootstrap/modal';

@Component({
  moduleId: module.id,
  selector: 'householdmember',
  templateUrl: 'household-member.component.html',
  styleUrls: ['household-member.component.css']
})
export class HouseholdMemberComponent implements OnInit {
  viewContainerRef:ViewContainerRef;

  @Input()
  public householdMember: HouseholdMember;
  @Input()
  public removeHouseholdMember: (HouseholdMember: HouseholdMember) => void;
  public id : string;


constructor(
    private grantService: GrantService,
    private route: ActivatedRoute,
    viewContainerRef: ViewContainerRef
  ) {
    this.viewContainerRef = viewContainerRef;
  }

  ngOnInit() {
     this.route.params.subscribe(params => {
        this.id = params['id'];
     });
  }

  remove(){
    if (window.confirm('Are you sure you want to delete household member?  You cannot undo this change.')) {
      if (this.id && this.householdMember.id) {
        this.grantService.deleteHouseholdMembersByGrantId(this.id, this.householdMember.id)
          .then(resp => {
            this.removeHouseholdMember(this.householdMember);
          });
      } else {
        this.removeHouseholdMember(this.householdMember);
      }
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/grant-form/household-member/household-member.component.ts